// Toggle this to switch between mock-up and current copy
export const USE_MOCKUP_COPY = true

export const mockupCopy = {
  hero: {
    tag: "For shops & restaurants in Ghana",
    headline: "Run your whole day from your phone \u2014 even when the lights go out.",
    subtitle: "TALLY takes the place of your paper book. Take orders, keep track of stock, and see your money \u2014 with or without internet.",
    ctaNote: "No sign-up needed. We set you up ourselves, in person."
  },
  problem: {
    kicker: "The problem",
    headline: "The notebook is doing too much.",
    cards: [
      { title: "Sales slip through the rush", body: "When it\u2019s busy, orders get missed and money doesn\u2019t add up at close." },
      { title: "You can\u2019t see what\u2019s left", body: "No quick way to know what\u2019s running low until it\u2019s already gone." },
      { title: "The light goes, work stops", body: "Power and data cuts are normal \u2014 and they shouldn\u2019t stop you selling." }
    ]
  },
  benefits: {
    kicker: "What you get",
    headline: "One place for the whole day.",
    items: [
      { n: "01", title: "Replace the paper book", body: "Orders, stock, expenses and the day\u2019s totals \u2014 all in one place, always with you." },
      { n: "02", title: "Works with no internet or power", body: "Take orders and record everything offline. It syncs on its own when you\u2019re back." },
      { n: "03", title: "Take an order in seconds", body: "Tap the plates, pick cash or mobile money, done. No typing, no fuss." },
      { n: "04", title: "Know your stock", body: "See what\u2019s running low and fix a count with a single tap." },
      { n: "05", title: "See your day", body: "Sales, expenses and what\u2019s left \u2014 clear at a glance when you close." },
      { n: "06", title: "Your records, safe", body: "No more lost notebooks. Everything is kept and backed up for you." }
    ]
  },
  offline: {
    kicker: "Works even without internet",
    headline: "No light? No data? Keep selling.",
    body: "Every order, expense and stock change is saved on your device the instant you tap. When the internet comes back, it sends everything on its own \u2014 you never wait, and you never lose a sale."
  },
  howItWorks: {
    kicker: "How it works",
    headline: "Up and running in three steps.",
    steps: [
      { n: "1", title: "Get set up", body: "We come to you, add your products and prices, and put TALLY on your phone or tablet." },
      { n: "2", title: "Run your day", body: "Take orders, record spending and track stock \u2014 on the device you already have." },
      { n: "3", title: "See your money", body: "Check the day\u2019s totals any time. It all keeps working, even offline." }
    ]
  },
  whoItsFor: {
    kicker: "Who it\u2019s for",
    headline: "Made for the business you run.",
    cards: [
      { title: "Restaurants & chop bars", body: "Ring up plates fast during service, track what\u2019s cooking, and know your takings at close." },
      { title: "Provision & retail shops", body: "Sell over the counter, keep stock straight, and see what\u2019s moving day to day." },
      { title: "More coming", body: "Salons, pharmacies and more \u2014 built to grow with your trade.", isComing: true }
    ]
  },
  trust: {
    kicker: "Trusted locally",
    headline: "Owners across Accra are switching from the book."
  },
  faq: {
    headline: "Questions owners ask",
    items: [
      { q: "How much does it cost?", a: "It depends on your business, so we talk it through together. Book a quick demo and we\u2019ll give you a straight answer \u2014 no surprises." },
      { q: "Do I need internet to use it?", a: "No. TALLY works fully offline and saves everything on your device. It sends to the cloud on its own whenever you\u2019re connected." },
      { q: "What device do I need?", a: "Any Android phone or tablet you already have. If you\u2019d like a dedicated tablet for the counter, we can advise." },
      { q: "Is my data safe?", a: "Yes. Your records are stored on the device and backed up securely \u2014 nothing is lost if a phone breaks or the power goes." },
      { q: "How do I get started?", a: "Message us on WhatsApp or book a demo. We set you up in person, usually the same day." }
    ]
  },
  finalCta: {
    headline: "See it with your own menu.",
    body: "Book a free demo on WhatsApp \u2014 we\u2019ll set you up and answer everything, including price."
  }
}

export const currentCopy = {
  hero: {
    tag: "",
    headline: "Replace your paper book with an app that never stops",
    subtitle: "Take orders, track stock, and see your day\u2014even when the internet\u2019s down. Built for Ghanaian businesses.",
    ctaNote: ""
  },
  problem: {
    kicker: "",
    headline: "Running a business on paper is harder than it should be",
    cards: [
      { title: "Lost Notebooks", body: "Paper records get lost or damaged" },
      { title: "No Stock Visibility", body: "Never know what is running low" },
      { title: "Unclear Totals", body: "End of day is a guessing game" }
    ]
  },
  benefits: {
    kicker: "",
    headline: "How TALLY Helps Your Business",
    items: [
      { n: "", title: "Replace the Paper Book", body: "Orders, stock, expenses, and daily totals in one place. No more lost notebooks." },
      { n: "", title: "Works Without Internet", body: "Take orders and record everything offline. Syncs when you are back online." },
      { n: "", title: "Take Orders in Seconds", body: "Ring up sales on your tablet or phone with just a few taps." },
      { n: "", title: "Know Your Stock", body: "See what is running low and correct counts with a tap." },
      { n: "", title: "See Your Day", body: "Sales, expenses, and what is left at a glance. Know where you stand." },
      { n: "", title: "Your Records, Safe", body: "No more lost notebooks. Your business data is backed up and secure." }
    ]
  },
  offline: {
    kicker: "",
    headline: "Works Even Without Internet",
    body: "Power cuts and network issues are normal in Ghana. TALLY keeps working through it all. Take orders, record stock, and check your totals\u2014offline. Everything syncs automatically when you are back online."
  },
  howItWorks: {
    kicker: "",
    headline: "Get Started in Three Simple Steps",
    steps: [
      { n: "1", title: "Get Set Up", body: "We help you install the app on your tablet or phone in minutes." },
      { n: "2", title: "Take Orders & Track Stock", body: "Start using it right away. Tap products to add them to orders." },
      { n: "3", title: "See Your Day, Even Offline", body: "Check your totals anytime. Everything syncs when you have internet." }
    ]
  },
  whoItsFor: {
    kicker: "",
    headline: "Built For Your Business",
    cards: [
      { title: "Restaurants", body: "Take orders at the counter, manage tables, track kitchen prep times, and never miss a sale during busy service." },
      { title: "Provisions & Retail", body: "Track stock levels, record expenses, manage suppliers, and know exactly what is selling and what is not." },
      { title: "More coming", body: "Salons, pharmacies and more \u2014 built to grow with your trade.", isComing: true }
    ]
  },
  trust: {
    kicker: "",
    headline: "Trusted by Growing Businesses"
  },
  faq: {
    headline: "Frequently Asked Questions",
    items: [
      { q: "How much does it cost?", a: "Pricing varies based on your business size and needs. Contact us for a personalized quote." },
      { q: "What devices does it work on?", a: "Any smartphone or tablet - Android or iOS. Works best on devices you already have." },
      { q: "Do I need internet all the time?", a: "No! The app works perfectly offline. It syncs when you have internet, but never stops working." },
      { q: "How long does setup take?", a: "Most businesses are up and running in under 30 minutes. We walk you through everything." },
      { q: "Is my data safe?", a: "Yes. Your data is encrypted and backed up. Only you can access your business information." }
    ]
  },
  finalCta: {
    headline: "Ready to Ditch the Paper Book?",
    body: "Book a free demo and see how TALLY can transform your business in under 30 minutes."
  }
}

export type HomeContent = typeof mockupCopy
